import api from "@services/apiList";
import instance from "@services/services";
import { ResponseType } from "../Types/ServicesType/servicesType";
import { getConstants } from "@utilifiles/methods/storage/storage";
import {
  ChatMessageResponse,
  ConversationDto,
  CreateConversationRequest,
  SendMessageRequest,
} from "./types";

const { messengerApi, SettingsApi } = api;

export type ClinicChatUser = {
  id: number;
  name: string;
  userGroupName?: string;
  status?: number;
  clinicId?: number;
};

const identity = () => {
  const { clinicId, userId, user } = getConstants();
  const numericUserId = Number(userId || user?.userId || 0);
  // web-socket-service expects clinicId === X-TenantId (tenantClinicId)
  const tenantClinicId = Number(user?.tenantClinicId || clinicId || 0);
  return {
    clinicId: tenantClinicId,
    tenantClinicId,
    userId: numericUserId,
  };
};

export const listConversations = async (): Promise<
  ResponseType<ConversationDto[] | null>
> => {
  const { userId, clinicId } = identity();
  const result = await instance.get(
    `${messengerApi.listConversations}/${userId}`,
    { params: { clinicId } },
  );
  return result.data;
};

export const createConversation = async (
  receiverId: number,
): Promise<ResponseType<ConversationDto | null>> => {
  const { userId, clinicId } = identity();
  const body: CreateConversationRequest = {
    clinicId,
    currentUserId: userId,
    receiverId,
  };
  const result = await instance.post(messengerApi.createConversation, body);
  return result.data;
};

export const getConversation = async (
  conversationId: number,
): Promise<ResponseType<ConversationDto | null>> => {
  const { userId, clinicId } = identity();
  const result = await instance.get(messengerApi.getConversation, {
    params: { conversationId, userId, clinicId },
  });
  return result.data;
};

export const getMessageHistory = async (
  conversationId: number,
  days = 7,
): Promise<ResponseType<ChatMessageResponse[] | null>> => {
  const { userId, clinicId } = identity();
  const result = await instance.get(
    `${messengerApi.messageHistory}/${conversationId}/messages`,
    { params: { userId, clinicId, days } },
  );
  return result.data;
};

export const sendMessageRest = async (
  conversationId: number,
  content: string,
): Promise<ResponseType<ChatMessageResponse | null>> => {
  const { userId, clinicId } = identity();
  const body: SendMessageRequest = {
    clinicId,
    senderId: userId,
    conversationId,
    content,
    messageType: "TEXT",
  };
  const result = await instance.post(messengerApi.sendMessage, body);
  return result.data;
};

export const markDeliveredRest = async (
  messageId: number,
): Promise<ResponseType<unknown>> => {
  const result = await instance.post(messengerApi.markDelivered, { messageId });
  return result.data;
};

export const markReadRest = async (
  conversationId: number,
  lastReadMessageId?: number,
): Promise<ResponseType<unknown>> => {
  const result = await instance.post(messengerApi.markRead, {
    conversationId,
    ...(lastReadMessageId != null ? { lastReadMessageId } : {}),
  });
  return result.data;
};

/** Clinic users for starting a private chat. Path clinicId = X-TenantId. */
export const getClinicUsersForChat = async (): Promise<
  ResponseType<ClinicChatUser[] | null>
> => {
  const { clinicId } = identity();
  const result = await instance.get(
    `${SettingsApi.getUserPrivilageUsers}${clinicId}`,
  );
  return result.data;
};
